module.exports = __webpack_public_path__ + "static/media/majors-oculus-university-of-arizona.0550becd.jpg";